"use client";

import { useState } from "react";
import Image from "next/image";

type Region = "sp" | "rj";

type FAQItem = {
  question: string;
  answer: string[];
};

type FAQSection = {
  title: string;
  items: FAQItem[];
};

type FAQRegionData = {
  label: string;
  title: string;
  subtitle: string;
  sections: FAQSection[];
};

const FAQ_DATA: Record<Region, FAQRegionData> = {
  rj: {
    label: "RJ",
    title: "Casa CazéTV Rio de Janeiro",
    subtitle: "Tudo o que você precisa saber",
    sections: [
      {
        title: "Sobre o evento",
        items: [
          {
            question: "O que é a Casa CazéTV?",
            answer: [
              "A Casa CazéTV é o ponto de encontro da galera durante a Copa do Mundo, com transmissões ao vivo, experiências interativas, convidados especiais, música, jogos e muita resenha no melhor estilo CazéTV.",
            ],
          },
          {
            question: "Onde e quando acontecerá a Casa CazéTV?",
            answer: [
              "A Casa CazéTV acontecerá em duas cidades, São Paulo e Rio de Janeiro, durante a Copa do Mundo de Futebol 2026. A Casa CazéTV no Rio de Janeiro acontecerá entre os dias 13 de junho e 19 de julho de 2026. Durante esse período, o espaço funcionará em todos os dias com jogos do Brasil, além da Final.",
              "O evento será realizado no Piér Mauá | Armazém 3 com acesso pela Av. Rodrigues Alves 10, Praça Mauá, Rio de Janeiro - CEP:20081-250. Clique aqui para ver no mapa.",
              "(https://maps.app.goo.gl/tyfg23BBdXpSqQfE6)",
            ],
          },
          {
            question: "Qual o horário de funcionamento?",
            answer: [
              "Os horários da Casa CazéTV acompanham a programação dos jogos. A agenda diária, com horários de abertura e encerramento, estará disponível em nossos canais oficiais.",
            ],
          },
          {
            question: "Como faço pra chegar na Casa CazéTV?",
            answer: [
              "De carro de aplicativo / táxi: utilize seu transporte por aplicativo preferido para chegar de forma mais cômoda e direta. O ponto ideal de chegada é o próprio endereço do Armazém 3 - Píer Mauá e é só atravessar o Trilho do VLT.",
              "De transporte público (VLT): para chegar de VLT, pegue uma composição da linha 1: sentido Aeroporto Santos Dumont e desça na estação Parada dos Navios. Retorne uma estação, sentido Roda Gigante. Sentido Rodoviária/Gentileza e desça na estação Parada dos Navios. A estação fica em frente ao armazém. Funcionamento: 05h às 23h.",
              "Bike Rio: se prefere chegar de Bike Rio, há duas estações de Bike Rio próximas ao Armazém: Estação Parada dos Navios e em frente ao prédio da L'Oréal.",
              "E lembre-se: se beber, não dirija.",
            ],
          },
          {
            question: "Tem estacionamento no local do evento?",
            answer: [
              "Há estacionamento 24h na região, incluindo o operado pela parceira do Píer Mauá (VMS), com acesso pela Av. Barão de Tefé.",
              "Também existem outras opções de estacionamentos particulares próximos. Recomendamos verificar previamente a disponibilidade e os horários de funcionamento nos dias de evento.",
              "A saída de pedestres ocorre pelo próprio Armazém 3, com frente para o Boulevard.",
              "Se beber, não dirija.",
            ],
          },
        ],
      },
      {
        title: "Ingressos",
        items: [
          {
            question: "Quais são os tipos de ingresso disponíveis?",
            answer: [
              "No Rio de Janeiro os ingressos disponibilizados serão do setor Geral:",
              "Geral: pra quem quer viver tudo, colado na galera!",
              "Telão de última geração com som imersivo; acesso a todas as ativações da Casa CazéTV; circulação livre entre Pista e Arquibancada (sem assentos marcados); acesso ao Food Park.",
              "Os valores variam de acordo com a data.",
            ],
          },
          {
            question: "Existe compra de pacote de ingressos?",
            answer: [
              "Os formatos de ingressos disponíveis poderão ser consultados por meio do site www.sympla.com.br/casacazetv.",
            ],
          },
          {
            question: "Onde posso comprar meu ingresso?",
            answer: [
              "Os ingressos estão disponíveis exclusivamente pela Sympla, por meio do site www.sympla.com.br/casacazetv. Não haverá bilheteria no Píer Mauá.",
            ],
          },
          {
            question: "Haverá venda de ingressos no local?",
            answer: [
              "Não. Não haverá venda de ingressos no local do evento.",
              "Para garantir sua participação, é necessário adquirir o ingresso antecipadamente pelo site oficial.",
            ],
          },
          {
            question:
              "Qual o valor da taxa de serviço nas compras realizadas por meio do site?",
            answer: [
              "Será aplicada taxa transacional de 10% sobre o valor do ingresso. Para ingressos com valores abaixo de R$39,99, será aplicada a taxa mínima de R$3,99 independentemente do valor do ingresso.",
            ],
          },
          {
            question: "Quantos ingressos posso comprar por CPF?",
            answer: [
              "Cada comprador poderá adquirir até 4 tipos de ingressos por dia da Casa CazéTV vinculados ao seu CPF.",
            ],
          },
          {
            question: "O evento terá meia-entrada?",
            answer: [
              "Alocação de 40% da capacidade vendável de acordo com a lei da meia-entrada. Para mais informações a respeito de elegibilidade e mais detalhes, clique aqui.",
            ],
          },
          {
            question:
              "Preciso apresentar carteira de estudante para entrar com ingresso de meia-entrada?",
            answer: [
              "Sim, para entrar no evento usando o ingresso de meia-entrada, você precisa comprovar o seu direito ao desconto. Você pode dar uma olhada nas regras específicas da meia-entrada clicando aqui.",
            ],
          },
          {
            question: "Existe limite para compra de ingresso de meia-entrada?",
            answer: [
              "Sobre a meia-entrada, não existe limite de compra, mas lembre-se de levar a documentação necessária para comprovar o seu direito ao benefício da meia-entrada, ok?",
            ],
          },
          {
            question: "Até quantos anos crianças entram gratuitamente?",
            answer: [
              "Crianças de até 4 anos não pagam ingresso, desde que acompanhadas de responsável. Verifique a seção de classificação etária para maiores informações.",
            ],
          },
          {
            question:
              "Quais são os benefícios da pré-venda com Cartões Itaú Visa?",
            answer: [
              "Ao aproveitar a pré-venda com o Cartões Itaú Visa, os clientes garantem a compra antecipada de ingressos de 29/04 a 05/05, obtendo um desconto exclusivo de 20%, parcelamento exclusivo em até 4x sem juros e acesso ao evento em uma fila exclusiva.",
            ],
          },
          {
            question:
              "Quais são os benefícios da compra com Cartões Itaú Visa?",
            answer: [
              "Após o período de pré-venda exclusivo, ao comprar ingressos com o Cartões Itaú Visa, os clientes garantem um desconto exclusivo de 10%, parcelamento exclusivo em até 4x sem juros e acesso ao evento em uma fila exclusiva.",
            ],
          },
          {
            question:
              "Quais as condições para participação da pré-venda exclusiva Cartões Itaú Visa?",
            answer: [
              "Somente os portadores do Cartões Itaú Visa terão acesso a pré-venda, que se inicia em 29/04. Se você não tem o Cartões Itaú Visa, pode solicitar o seu clicando aqui.",
            ],
          },
          {
            question:
              "Comprei meu ingresso online. Preciso imprimi-lo para conseguir entrar?",
            answer: [
              "Não. Basta apresentar o QR code diretamente no celular, com boa visibilidade, na entrada do evento.",
              "Se preferir, você também pode acessar seu ingresso pelo aplicativo da Sympla usando o mesmo e-mail utilizado na compra.",
            ],
          },
          {
            question:
              "Tive um imprevisto e não poderei ir. Posso dar meu ingresso pra outra pessoa?",
            answer: [
              "Sim, desde que o ingresso ainda não tenha sido utilizado e a transferência seja feita diretamente na plataforma da Sympla.",
            ],
          },
          {
            question:
              "Qual o prazo máximo para fazer a transferência do meu ingresso?",
            answer: [
              "A transferência poderá ser realizada até 24h antes do evento.",
            ],
          },
          {
            question: "Posso cancelar meu ingresso e obter reembolso?",
            answer: [
              "Sim, desde que o pedido de cancelamento seja feito dentro do prazo estabelecido e de acordo com a política de reembolso: https://ajuda.sympla.com.br/hc/pt-br/articles/6479364031252-Como-funciona-o-reembolso-do-meu-pedido",
            ],
          },
          {
            question:
              "Comprei mais de um ingresso, é possível cancelar somente um dos ingressos?",
            answer: ["Sim, é possível cancelar somente um ingresso da compra."],
          },
        ],
      },
      {
        title: "Acesso e documentos",
        items: [
          {
            question: "Qual a classificação etária?",
            answer: [
              "Menores de até 15 anos: entrada permitida apenas se acompanhados por responsável legal ou adulto autorizado. Será necessário apresentar o Termo de Declaração de Responsabilidade para Menores Acompanhados, devidamente preenchido e assinado.",
              "Menores de 16 e 17 anos: poderão acessar o evento desacompanhados, desde que apresentem o Termo de Autorização para Entrada de Menores Desacompanhados, assinado por um responsável legal.",
            ],
          },
          {
            question: "É permitido levar animais de estimação ao evento?",
            answer: [
              "A entrada de animais de estimação não é permitida, com exceção de cães-guia ou de assistência cão-guia. O ambiente fechado, a música alta e a densidade de público podem estressá-los e gerar incidentes. Por isso, não é permitida a entrada de animais de estimação. Cães-guia ou cães de assistência entram normalmente com seus tutores.",
            ],
          },
          {
            question:
              "Quais documentos preciso levar pra entrar na Casa CazéTV?",
            answer: [
              "Para que a gente possa confirmar a sua identidade, é necessário levar um documento oficial nacional com foto, como RG, CNH ou passaporte.",
              "Além disso, se o seu ingresso é o de meia-entrada, será necessário apresentar um documento que comprove o seu direito à meia-entrada.",
            ],
          },
          {
            question: "O que você precisa ter em mãos na chegada?",
            answer: [
              "Será permitido o acesso ao evento mediante apresentação do QR Code do ingresso (impresso ou no celular) e de um documento oficial com foto, como RG, CNH ou passaporte. Ambos são obrigatórios para entrada no evento.",
              "Além disso, se o seu ingresso é o de meia-entrada, será necessário apresentar um documento que comprove o seu direito à meia-entrada.",
            ],
          },
          {
            question: "O que eu não posso levar pro evento?",
            answer: [
              "Para garantir a segurança de todas as pessoas, não será permitido entrar com capacetes, skates, paus de selfie, guarda-chuvas, embalagens rígidas com tampa, cadeiras ou bancos, objetos de vidro, armas de fogo, munições, airsoft, paintball ou quaisquer réplicas realistas, armas brancas e objetos perfurantes, cortantes ou pontiagudos, artefatos explosivos ou pirotécnicos, animais, substâncias inflamáveis, tóxicas, líquidos, sólidos ou gases inflamáveis ou combustíveis, sprays ou aerossóis de uso ofensivo, alimentos, bebidas, bebidas alcoólicas de qualquer tipo e em qualquer embalagem, bolsas de grande porte, objetos e recipientes de vidro ou latas metálicas cheias, garrafas PET acima de 600 ml, aparelhos de bloqueio ou interferência de sinal, lasers ou feixes de luz de alta intensidade, equipamentos profissionais de captação ou transmissão de áudio e vídeo sem credenciamento prévio, drones, materiais de propaganda, faixas, banners, cartazes ou adesivos com conteúdo comercial, político, eleitoral, ideológico, religioso ou ofensivo, mochilas rígidas, malas com rodinhas, hard cases, coolers térmicos ou volumes superiores a 30 x 30 x 15 cm, instrumentos sonoros de alto volume não autorizados, roupas ou acessórios com pontas e metal agressivo e veículos pessoais motorizados ou não, como skates, patins, hoverboards, scooters e bicicletas dobráveis, exceto dispositivos de mobilidade assistida.",

              "Também não será permitida a entrada com cigarros eletrônicos, vapes, pods, cachimbos, charutos ou quaisquer outros produtos fumígenos, bem como substâncias destinadas à inalação, vaporização ou consumo similar.",

              "Fica igualmente proibida a entrada com vuvuzelas, apitos, cornetas, buzinas, megafones, caixas de som, amplificadores ou quaisquer equipamentos sonoros que possam interferir na programação, na transmissão, na operação do evento ou na experiência dos demais participantes.",

              "Tintas spray, marcadores permanentes ou qualquer material destinado à pichação, vandalismo ou depredação também não são permitidos. Guarda-chuvas com haste metálica e/ou ponta rígida seguem proibidos.",

              "Não será permitida a entrada utilizando camisas, bandeiras, faixas, bonés, adesivos, copos ou quaisquer artigos que façam menção ou referência a torcidas organizadas, organizações criminosas ou que contenham conteúdo que faça apologia a crimes, violência, discriminação, preconceito, intolerância, atividades ilícitas ou que possuam caráter ofensivo, imoral, obsceno, político-partidário, eleitoral, ideológico ou religioso.",

              "É permitida a entrada com copos de água plásticos descartáveis e garrafas de água plásticas flexíveis lacradas.",

              "Todas as pessoas portadoras de ingresso serão submetidas a inspeções por meio de detector de metais e revistas corporais. Os objetos não autorizados poderão ser retidos, descartados ou ter sua entrada recusada, sem qualquer direito a reembolso ou indenização.",

              "A Organização reserva-se o direito de, a qualquer momento e a seu exclusivo critério, restringir ou impedir a entrada e permanência de quaisquer objetos, materiais, equipamentos, vestimentas, acessórios ou itens não expressamente previstos nesta lista, sempre que entender que possam representar risco à segurança, ao conforto, à experiência dos participantes, à operação do evento, ao cumprimento da legislação aplicável ou aos direitos e interesses dos organizadores, patrocinadores, parceiros e demais envolvidos.",
            ],
          },
          {
            question: "Qual a política de entrada e revista no evento?",
            answer: [
              "A segurança de todos os participantes é nossa prioridade. Para garantir um ambiente seguro, a organização poderá realizar revista pessoal e de pertences na entrada do evento, em conformidade com as legislações vigentes e sempre de maneira humanizada, respeitosa e inclusiva.",
              "A organização poderá disponibilizar estrutura e recursos de segurança adequados para a detecção de objetos proibidos ou potencialmente perigosos, incluindo equipamentos e procedimentos específicos de inspeção. Objetos considerados proibidos poderão ser retidos pela equipe de segurança.",
            ],
          },
          {
            question: "Haverá monitoramento e suporte dentro do evento?",
            answer: [
              "Sim. Todas as áreas contam com câmeras de CFTV e equipes de segurança uniformizadas. Se precisar de ajuda, procure qualquer colaborador com crachá STAFF.",
            ],
          },
          {
            question: "Posso entrar e sair do evento no mesmo dia?",
            answer: [
              "Não. A entrada é única. Ao sair, o ingresso do dia é encerrado e não será permitida a reentrada.",
            ],
          },
          {
            question:
              "O evento dispõe de acessibilidade para Pessoas Com Deficiência?",
            answer: ["Sim. O espaço conta com rampas para acesso."],
          },
        ],
      },
      {
        title: "Estrutura e experiência",
        items: [
          {
            question: "O que vai ter na Casa CazéTV?",
            answer: [
              "Transmissões ao vivo dos jogos, estúdio da CazéTV com convidados, ativações de marcas, espaços instagramáveis, atrações e áreas de convivência.",
            ],
          },
          {
            question: "Haverá venda de comida no evento?",
            answer: [
              "Sim! O espaço conta com uma área de alimentação com diversas opções de comidas. As refeições são adquiridas diretamente pelos participantes, não sendo fornecida alimentação pela organização do Evento.",
            ],
          },
          {
            question: "E bebida alcoólica?",
            answer: [
              "Sim, haverá venda de bebidas alcoólicas para maiores de 18 anos.",
            ],
          },
          {
            question: "Posso levar comida ou bebida de fora?",
            answer: [
              "Não é permitido entrar com alimentos ou bebidas externas.",
            ],
          },
          {
            question: "Haverá guarda-volumes?",
            answer: [
              "Não disponibilizamos espaço para guarda-volumes. A guarda e segurança de objetos pessoais é de responsabilidade única e exclusiva de cada visitante e participante do evento. Não nos responsabilizamos pela perda de objetos pessoais.",
            ],
          },
          {
            question: "E se eu perder um item? Haverá achados e perdidos?",
            answer: [
              "Sim. Neste caso é só procurar algum staff do evento e pedir que entrem em contato com o CAEX do Evento (Central de Apoio à Execução) ou dirigir-se ao balcão de achados e perdidos no credenciamento público.",
            ],
          },
        ],
      },
    ],
  },
  sp: {
    label: "SP",
    title: "Casa CazéTV São Paulo",
    subtitle: "Tudo o que você precisa saber",
    sections: [
      {
        title: "Sobre o evento",
        items: [
          {
            question: "O que é a Casa CazéTV?",
            answer: [
              "A Casa CazéTV é o ponto de encontro da galera durante a Copa do Mundo, com transmissões ao vivo, experiências interativas, convidados especiais, música, jogos e muita resenha no melhor estilo CazéTV.",
            ],
          },
          {
            question: "Onde e quando acontecerá a Casa CazéTV?",
            answer: [
              "A Casa CazéTV acontecerá em duas cidades, São Paulo e Rio de Janeiro, durante a Copa do Mundo de Futebol 2026.",
              "A Casa CazéTV São Paulo acontecerá entre os dias 13 de junho e 19 de julho de 2026. Durante esse período, o espaço funcionará em todos os dias com jogos do Brasil, além de sábados e domingos em que houver qualquer jogo. A partir das quartas de final, a Casa CazéTV abrirá em todos os jogos.",
              "Novas datas e horários de funcionamento poderão ser divulgados ao longo do torneio, de acordo com a programação oficial.",
              "O evento será realizado no Parque Villa-Lobos, com acesso pelo Acesso 3 | Principal, Av. Prof. Fonseca Rodrigues, 2.001 - Alto de Pinheiros, São Paulo - SP, 05461-010, com entrada para pedestres e veículos. Clique aqui para ver no mapa.",
            ],
          },
          {
            question: "Qual o horário de funcionamento?",
            answer: [
              "Os horários da Casa CazéTV acompanham a programação dos jogos. A agenda diária, com horários de abertura e encerramento, estará disponível em nossos canais oficiais.",
            ],
          },
          {
            question: "Como faço pra chegar na Casa CazéTV?",
            answer: [
              "De carro de aplicativo / táxi: o acesso mais próximo da Casa CazéTV é pelo Acesso 3 - Principal, na Av. Prof. Fonseca Rodrigues, 2.001, com entrada permitida para pedestres e veículos.",
              "De transporte público: se você vai de metrô ou trem, utilize a Linha 4 - Amarela, desça na estação Pinheiros e faça a baldeação para a Linha 9 - Esmeralda da CPTM. Desça na estação Villa-Lobos - Jaguaré (Linha 9 - Esmeralda | Osasco-Grajaú) e siga em breve caminhada até a Casa CazéTV. O horário de funcionamento do metrô (Linha 4 - Amarela) e do trem (Linha 9 - Esmeralda) é até meia-noite, todos os dias.",
              "De carro: para quem optar por ir de carro, o principal acesso ao Parque Villa-Lobos é pela Marginal Pinheiros. Seguir até a Avenida Dra. Ruth Cardoso, que leva diretamente à Avenida Queiroz Filho. Mas, não esqueça: o estacionamento é limitado, então é necessário chegar cedo para garantir a vaga!",
              "Entrada e saída do estacionamento no Parque Villa-Lobos ocorre pelo Portão 2 - Av. Queiroz Filho, 1.315, próximo à Roda Rico.",
              "Depois de estacionar, é preciso caminhar cerca de 10 minutos até o embarque/desembarque Casa CazéTV. Esse tempo pode variar um pouco dependendo da lotação do estacionamento.",
              "Os valores do estacionamento são definidos e cobrados pela operadora do local, não sendo gerenciados pela organização do evento. Consulte a tabela de preços aqui.",
              "E lembre-se: se beber, não dirija.",
            ],
          },
          {
            question: "Tem estacionamento no local do evento?",
            answer: [
              "Sim, porém o estacionamento do Parque Villa-Lobos é cobrado.",
              "Fique atento à tabela de preços, disponível para consulta aqui.",
              "E lembre-se: se beber, não dirija.",
            ],
          },
        ],
      },
      {
        title: "Ingressos",
        items: [
          {
            question: "Quais são os tipos de ingresso disponíveis?",
            answer: [
              "Em São Paulo, teremos duas categorias de ingressos disponíveis: Cativa e Geral.",
              "Geral: para quem quer viver tudo, colado na galera!",
              "Telão de última geração com som de alta qualidade; acesso a todas as ativações da Casa CazéTV; circulação livre entre Pista e Arquibancada (sem assentos marcados); acesso ao Food Park.",
              "Cativa: mais conforto para curtir cada momento, sem perder a emoção.",
              "Todos os benefícios da Geral, mais: acesso ao mezanino; vista privilegiada do telão; open bar (cerveja, água e refrigerante).",
              "Os valores variam de acordo com a data e o local selecionados.",
            ],
          },
          {
            question: "Existe compra de pacote de ingressos?",
            answer: [
              "Os formatos de ingressos disponíveis poderão ser consultados por meio do site www.sympla.com.br/casacazetv.",
            ],
          },
          {
            question: "Onde posso comprar meu ingresso?",
            answer: [
              "Os ingressos estão disponíveis exclusivamente pela Sympla, por meio do site www.sympla.com.br/casacazetv.",
            ],
          },
          {
            question: "Haverá venda de ingressos no local?",
            answer: [
              "A venda no local está sujeita à disponibilidade. Para garantir sua entrada, recomendamos a compra antecipada pelo site oficial.",
            ],
          },
          {
            question:
              "Qual o valor da taxa de serviço nas compras realizadas por meio do site?",
            answer: [
              "Será aplicada taxa transacional de 10% sobre o valor do ingresso. Para ingressos com valores abaixo de R$39,99, será aplicada a taxa mínima de R$3,99 independentemente do valor do ingresso.",
            ],
          },
          {
            question: "Quantos ingressos posso comprar por CPF?",
            answer: [
              "Cada comprador poderá adquirir até 4 tipos de ingressos por dia da Casa CazéTV vinculados ao seu CPF.",
            ],
          },
          {
            question: "O evento terá meia-entrada?",
            answer: [
              "Alocação de 40% da capacidade vendável de acordo com a lei da meia-entrada. Para mais informações a respeito de elegibilidade e outros detalhes, clique aqui.",
            ],
          },
          {
            question:
              "Preciso apresentar carteira de estudante para entrar com ingresso de meia-entrada?",
            answer: [
              "Sim, para entrar no evento usando o ingresso de meia-entrada, você precisa comprovar o seu direito ao desconto. Você pode dar uma olhada nas regras específicas da meia-entrada clicando aqui.",
            ],
          },
          {
            question: "Existe limite para compra de ingresso de meia-entrada?",
            answer: [
              "Não existe limite de compra, mas é necessário levar a documentação necessária para comprovar o seu direito ao benefício da meia-entrada.",
            ],
          },
          {
            question: "Até quantos anos crianças entram gratuitamente?",
            answer: [
              "Crianças de até 4 anos não pagam ingresso, desde que acompanhadas de responsável. Verifique a seção de classificação etária para maiores informações.",
            ],
          },
          {
            question:
              "Quais são os benefícios da pré-venda com Cartões Itaú Visa?",
            answer: [
              "Ao aproveitar a pré-venda com Cartões Itaú Visa, os clientes garantem a compra antecipada de ingressos de 29/04 a 05/05, obtendo um desconto exclusivo de 20%, parcelamento exclusivo em até 4x sem juros e acesso ao evento em uma fila exclusiva.",
            ],
          },
          {
            question:
              "Quais são os benefícios da compra com Cartões Itaú Visa?",
            answer: [
              "Após o período de pré-venda exclusivo, ao comprar ingressos com os Cartões Itaú Visa, os clientes garantem um desconto exclusivo de 10%, parcelamento exclusivo em até 4x sem juros e acesso ao evento em uma fila exclusiva.",
            ],
          },
          {
            question:
              "Quais as condições para participação da pré-venda exclusiva Cartões Itaú Visa?",
            answer: [
              "Somente os portadores de Cartões Itaú Visa terão acesso à pré-venda, que se inicia em 29/04. Se você não tem Cartões Itaú Visa, pode solicitar o seu clicando aqui.",
            ],
          },
          {
            question:
              "Comprei meu ingresso online. Preciso imprimi-lo para conseguir entrar?",
            answer: [
              "Não. Basta apresentar o QR code diretamente no celular, com boa visibilidade, na entrada do evento.",
              "Se preferir, você também pode acessar seu ingresso pelo aplicativo da Sympla usando o mesmo e-mail utilizado na compra.",
            ],
          },
          {
            question:
              "Tive um imprevisto e não poderei ir. Posso dar meu ingresso pra outra pessoa?",
            answer: [
              "Sim, desde que o ingresso ainda não tenha sido utilizado e a transferência seja feita diretamente na plataforma da Sympla.",
            ],
          },
          {
            question:
              "Qual o prazo máximo para fazer a transferência do meu ingresso?",
            answer: [
              "A transferência de titularidade poderá ser realizada até 24h antes do evento pelo aplicativo da Sympla do portador do ingresso.",
            ],
          },
          {
            question: "Posso cancelar meu ingresso e obter reembolso?",
            answer: [
              "Sim. Você pode solicitar o cancelamento do seu ingresso e o respectivo reembolso dentro do prazo de até 7 (sete) dias corridos após a compra, conforme previsto no Código de Defesa do Consumidor (CDC) para compras realizadas fora do estabelecimento comercial, como pela internet.",
              "Após esse período, o cancelamento poderá seguir as regras e os prazos estabelecidos na política da plataforma e do evento.",
              "Para mais detalhes sobre como funciona o processo de reembolso pela Sympla, acesse: https://ajuda.sympla.com.br/hc/pt-br/articles/6479364031252-Como-funciona-o-reembolso-do-meu-pedido.",
            ],
          },
          {
            question:
              "Comprei mais de um ingresso, é possível cancelar somente um dos ingressos?",
            answer: ["Sim, é possível cancelar somente um ingresso da compra."],
          },
        ],
      },
      {
        title: "Acesso e documentos",
        items: [
          {
            question: "Qual a classificação etária?",
            answer: [
              "Menores de 15 anos: entrada permitida apenas se acompanhados por responsável legal ou adulto autorizado. Será necessário apresentar o Termo de Declaração de Responsabilidade para Menores Acompanhados, devidamente preenchido e assinado.",
              "Menores de 16 e 17 anos: poderão acessar o evento desacompanhados, desde que apresentem o Termo de Autorização para Entrada de Menores Desacompanhados, assinado por um responsável legal.",
            ],
          },
          {
            question: "É permitido levar animais de estimação ao evento?",
            answer: [
              "A entrada de animais de estimação não é permitida, com exceção de cães-guia ou de assistência. O ambiente fechado, a música alta e a densidade de público podem estressá-los e gerar incidentes. Por isso, não é permitida a entrada de animais de estimação. Cães-guia ou cães de assistência entram normalmente com seus tutores.",
            ],
          },
          {
            question:
              "Quais documentos preciso levar pra entrar na Casa CazéTV?",
            answer: [
              "Para que a gente possa confirmar a sua identidade, é necessário levar um documento oficial nacional com foto, como RG, CNH ou passaporte.",
              "Além disso, se o seu ingresso é o de meia-entrada, será necessário apresentar um documento que comprove o seu direito à meia-entrada.",
            ],
          },
          {
            question: "O que você precisa ter em mãos na chegada?",
            answer: [
              "Será permitido o acesso ao evento mediante apresentação do QR code do ingresso (impresso ou no celular) e de um documento oficial com foto, como RG, CNH ou passaporte. Ambos são obrigatórios para entrada no evento.",
              "Além disso, se o seu ingresso é o de meia-entrada, será necessário apresentar um documento que comprove o seu direito à meia-entrada.",
            ],
          },
          {
            question: "O que eu não posso levar pro evento?",
            answer: [
              "Para garantir a segurança de todas as pessoas, não será permitido entrar com capacetes, skates, paus de selfie, guarda-chuvas, embalagens rígidas com tampa, cadeiras ou bancos, objetos de vidro, armas de fogo, munições, airsoft, paintball ou quaisquer réplicas realistas, armas brancas e objetos perfurantes, cortantes ou pontiagudos, artefatos explosivos ou pirotécnicos, animais, substâncias inflamáveis, tóxicas, líquidos, sólidos ou gases inflamáveis ou combustíveis, sprays ou aerossóis de uso ofensivo, alimentos, bebidas, bebidas alcoólicas de qualquer tipo e em qualquer embalagem, bolsas de grande porte, objetos e recipientes de vidro ou latas metálicas cheias, garrafas PET acima de 600 ml, aparelhos de bloqueio ou interferência de sinal, lasers ou feixes de luz de alta intensidade, equipamentos profissionais de captação ou transmissão de áudio e vídeo sem credenciamento prévio, drones, materiais de propaganda, faixas, banners, cartazes ou adesivos com conteúdo comercial, político, eleitoral, ideológico, religioso ou ofensivo, mochilas rígidas, malas com rodinhas, hard cases, coolers térmicos ou volumes superiores a 30 x 30 x 15 cm, instrumentos sonoros de alto volume não autorizados, roupas ou acessórios com pontas e metal agressivo e veículos pessoais motorizados ou não, como skates, patins, hoverboards, scooters e bicicletas dobráveis, exceto dispositivos de mobilidade assistida.",

              "Também não será permitida a entrada com cigarros eletrônicos, vapes, pods, cachimbos, charutos ou quaisquer outros produtos fumígenos, bem como substâncias destinadas à inalação, vaporização ou consumo similar.",

              "Fica igualmente proibida a entrada com vuvuzelas, apitos, cornetas, buzinas, megafones, caixas de som, amplificadores ou quaisquer equipamentos sonoros que possam interferir na programação, na transmissão, na operação do evento ou na experiência dos demais participantes.",

              "Tintas spray, marcadores permanentes ou qualquer material destinado à pichação, vandalismo ou depredação também não são permitidos. Guarda-chuvas com haste metálica e/ou ponta rígida seguem proibidos.",

              "Não será permitida a entrada utilizando camisas, bandeiras, faixas, bonés, adesivos, copos ou quaisquer artigos que façam menção ou referência a torcidas organizadas, organizações criminosas ou que contenham conteúdo que faça apologia a crimes, violência, discriminação, preconceito, intolerância, atividades ilícitas ou que possuam caráter ofensivo, imoral, obsceno, político-partidário, eleitoral, ideológico ou religioso.",

              "É permitida a entrada com copos de água plásticos descartáveis e garrafas de água plásticas flexíveis lacradas.",

              "Todas as pessoas portadoras de ingresso serão submetidas a inspeções por meio de detector de metais e revistas corporais. Os objetos não autorizados poderão ser retidos, descartados ou ter sua entrada recusada, sem qualquer direito a reembolso ou indenização.",

              "A Organização reserva-se o direito de, a qualquer momento e a seu exclusivo critério, restringir ou impedir a entrada e permanência de quaisquer objetos, materiais, equipamentos, vestimentas, acessórios ou itens não expressamente previstos nesta lista, sempre que entender que possam representar risco à segurança, ao conforto, à experiência dos participantes, à operação do evento, ao cumprimento da legislação aplicável ou aos direitos e interesses dos organizadores, patrocinadores, parceiros e demais envolvidos.",
            ],
          },
          {
            question: "Qual a política de entrada e revista no evento?",
            answer: [
              "A segurança de todos os participantes é nossa prioridade. Para garantir um ambiente seguro, a organização poderá realizar revista pessoal e de pertences na entrada do evento, em conformidade com as legislações vigentes e sempre de maneira humanizada, respeitosa e inclusiva.",
              "A organização poderá disponibilizar estrutura e recursos de segurança adequados para a detecção de objetos proibidos ou potencialmente perigosos, incluindo equipamentos e procedimentos específicos de inspeção. Objetos considerados proibidos poderão ser retidos pela equipe de segurança.",
            ],
          },
          {
            question: "Haverá monitoramento e suporte dentro do evento?",
            answer: [
              "Sim. Todas as áreas contam com câmeras de CFTV e equipes de segurança uniformizadas. Se precisar de ajuda, procure qualquer colaborador com crachá STAFF.",
            ],
          },
          {
            question: "Posso entrar e sair do evento no mesmo dia?",
            answer: [
              "Não. A entrada é única. Ao sair, o ingresso do dia é encerrado e não será permitida a reentrada.",
            ],
          },
          {
            question:
              "O evento dispõe de acessibilidade para Pessoas Com Deficiência?",
            answer: [
              "Sim. O espaço conta com rampas e elevadores para acesso.",
            ],
          },
        ],
      },
      {
        title: "Estrutura e experiência",
        items: [
          {
            question: "O que vai ter na Casa CazéTV?",
            answer: [
              "Transmissões ao vivo dos jogos, convidados, ativações de marcas, espaços instagramáveis, shows e áreas de convivência.",
            ],
          },
          {
            question: "Haverá venda de comida no evento?",
            answer: [
              "Sim. O espaço conta com uma área de alimentação com diversas opções de comidas. As refeições são adquiridas diretamente pelos participantes, não sendo fornecida alimentação pela organização do evento.",
            ],
          },
          {
            question: "E bebida alcoólica?",
            answer: [
              "Sim, haverá venda de bebidas alcoólicas para maiores de 18 anos.",
            ],
          },
          {
            question: "Posso levar comida ou bebida de fora?",
            answer: [
              "Não é permitido entrar com alimentos ou bebidas externas.",
            ],
          },
          {
            question: "Haverá guarda-volumes?",
            answer: [
              "Não disponibilizamos espaço para guarda-volumes. A guarda e segurança de objetos pessoais é de responsabilidade única e exclusiva de cada visitante e participante do evento. Não nos responsabilizamos pela perda de objetos pessoais.",
            ],
          },
          {
            question: "E se eu perder um item? Haverá achados e perdidos?",
            answer: [
              "Sim. Basta procurar algum staff do evento e pedir que entrem em contato com o CAEX do Evento (Central de Apoio à Execução).",
            ],
          },
        ],
      },
    ],
  },
};

export default function FAQ() {
  const [region, setRegion] = useState<Region>("sp");
  const [openItem, setOpenItem] = useState("sp-0-0");

  const currentFAQ = FAQ_DATA[region];

  function handleRegionChange(nextRegion: Region) {
    setRegion(nextRegion);
    setOpenItem(`${nextRegion}-0-0`);
  }

  function toggleItem(itemId: string) {
    setOpenItem((current) => (current === itemId ? "" : itemId));
  }

  return (
    <section className="faq-section reveal-up" id="faq">
      <div className="lg:pt-10 pl-5 pt-10">
        <div
          className="text-[#2033ef] border-[#2033ef] w-fit p-4"
          style={{ borderWidth: 1, marginBottom: 20 }}
        >
          <div
            className="flex flex-row gap-2 items-center font-bold text-[11px]"
            style={{
              paddingLeft: 6,
              paddingRight: 6,
              paddingTop: 0,
              paddingBottom: 0,
              height: 5,
            }}
          >
            <div className="h-2 w-2 rounded-full bg-[#fec822]" />{" "}
            <p>AINDA COM DÚVIDAS?</p>
          </div>
        </div>

        <div className="faq-title-row">
          <div className="">
            <h1 className="font-extrabold text-[#2033ef] text-[34px]">FAQ</h1>
          </div>
        </div>
      </div>
      <div className="section-container">
        <div className="faq-shell">
          <div className="faq-heading">
            <div
              className="faq-filters"
              role="tablist"
              aria-label="Filtro por região"
            >
              {(["sp", "rj"] as Region[]).map((option) => {
                const isActive = option === region;

                return (
                  <button
                    key={option}
                    type="button"
                    className={`faq-filter ${isActive ? "is-active" : ""}`}
                    onClick={() => handleRegionChange(option)}
                  >
                    {FAQ_DATA[option].label}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="faq-sections">
            {currentFAQ.sections.map((section, sectionIndex) => (
              <div className="faq-section-block" key={section.title}>
                <div className="faq-section-label">{section.title}</div>

                <div className="faq-list">
                  {section.items.map((item, itemIndex) => {
                    const itemId = `${region}-${sectionIndex}-${itemIndex}`;
                    const isOpen = openItem === itemId;

                    return (
                      <article
                        key={item.question}
                        className={`faq-item ${isOpen ? "is-open" : ""}`}
                      >
                        <button
                          type="button"
                          className="faq-question"
                          onClick={() => toggleItem(itemId)}
                          aria-expanded={isOpen}
                        >
                          <span>{item.question}</span>
                          <span className="faq-icon" aria-hidden="true">
                            {isOpen ? "−" : "+"}
                          </span>
                        </button>

                        {isOpen ? (
                          <div className="faq-answer">
                            {item.answer.map((paragraph) => (
                              <p key={paragraph}>{paragraph}</p>
                            ))}
                          </div>
                        ) : null}
                      </article>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .faq-section {
          background: #fff;
          padding: 4rem 0 5rem;
          scroll-margin-top: 6.5rem;
        }

        .faq-shell {
          display: grid;
          gap: 2rem;
        }

        .faq-heading {
          display: grid;
          gap: 1.25rem;
        }

        .faq-badge {
          display: inline-flex;
          width: fit-content;
          align-items: center;
          gap: 0.75rem;
          border: 1px solid #fec822;
          color: #fec822;
          padding: 0.9rem 1.1rem;
          font-size: 0.72rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .faq-badge-dot {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 999px;
          background: #fec822;
        }

        .faq-title-row {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .faq-region-title {
          color: #fec822;
          font-size: clamp(2rem, 4vw, 3.25rem);
          font-weight: 950;
          line-height: 0.96;
          text-transform: uppercase;
        }

        .faq-region-subtitle {
          margin-top: 0.5rem;
          color: rgba(255, 255, 255, 0.86);
          font-size: 0.95rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.08em;
        }

        .faq-filters {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .faq-filter {
          min-width: 92px;
          border: 1px solid #2033ef;
          border-radius: 999px;
          background: transparent;
          color: #2033ef;
          padding: 0.85rem 1.2rem;
          font-size: 0.95rem;
          font-weight: 900;
          cursor: pointer;
        }

        .faq-filter.is-active {
          background: #fec822;
          border-color: #fec822;
          color: #2033ef;
        }

        .faq-sections {
          display: grid;
          gap: 1.5rem;
        }

        .faq-section-block {
          display: grid;
          gap: 0.85rem;
        }

        .faq-section-label {
          color: #2033ef;
          font-size: 0.95rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 0.1em;
        }

        .faq-list {
          display: grid;
          gap: 0.9rem;
        }

        .faq-item {
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 24px;
          background: rgba(255, 255, 255, 0.08);
          overflow: hidden;
          backdrop-filter: blur(10px);
        }

        .faq-item.is-open {
          background: white;
          border-color: white;
          color: #fff;
        }

        .faq-question {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          border: 0;
          background: #2033ef;
          color: inherit;
          padding: 1.25rem 1.35rem;
          text-align: left;
          font-size: 1rem;
          font-weight: 800;
          cursor: pointer;
        }

        .faq-icon {
          flex-shrink: 0;
          width: 2rem;
          height: 2rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 999px;
          background: #fec822;
          color: #2033ef;
          font-size: 1.4rem;
          line-height: 1;
        }

        .faq-answer {
          padding: 0 1.35rem 1.35rem;
          display: grid;
          gap: 0.85rem;
          color: #fff;
          font-size: 0.96rem;
          line-height: 1.6;
          background: #2033ef;
        }

        @media (max-width: 768px) {
          .faq-section {
            padding: 3rem 0 4rem;
          }

          .faq-title-row {
            align-items: flex-start;
          }

          .faq-question {
            padding: 1.05rem 1.1rem;
            font-size: 0.95rem;
          }

          .faq-answer {
            padding: 0 1.1rem 1.1rem;
            font-size: 0.92rem;
          }
        }
      `}</style>
    </section>
  );
}
